import Api from './Api';

const Products = () => {
  return Api().get('/Products');
};

const Product = (id) => {
  return Api().get(`/products/${id}`);
};

const RemoveProducts = (id) => {
  return Api().delete(`/products/${id}`);
};

const EditProduct = (id, data) => {
  return Api().put(`/products/${id}`, data);
};

const EditProductImage = (id, data) => {
  return Api().put(`/products/image/${id}`, data);
};

export { Products, Product, RemoveProducts, EditProduct, EditProductImage };
